import axios from "axios";
import { getToken } from "./utils/StorageUtil";

let apiHost = "https://gbpapi.gbpboost.com";
let devApiHost = "https://devapi.boostaware.com"; //"https://devapi.boostaware.com"; //'https://dev-api.gbpboost.com';
let localApiHost = "https://localhost:7256";
const apiHeader = "X-API-KEY";
const apiHeaderValue = "IQO?EXZiro?-|m%X15;vx1Q>L}bxb,<?M7=(J56Ss[K7o+;^6a7}J!dW6i8LJk2";

if (window.location.origin) {
    if (window.location.origin.indexOf("localhost") > -1) {
        // apiHost = localApiHost;
        apiHost = devApiHost;
    } else if (window.location.origin.indexOf("dev.") > -1 || window.location.origin.indexOf("dev-") > -1) {
        // apiHost = localApiHost;
        apiHost = devApiHost;
    }
}

// setup axios to inject the authorization header automatically
// if token is present in store
axios.interceptors.request.use((config) => {
    let token = getToken();

    if (token && token.trim() !== "") {
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
});

export const GetSEOReportGridWithSproc = async (campaignId, reportId, targetId, compareTo) => {
    let start = performance.now();

    const response = await axios
        .get(
            apiHost +
                `/campaigns/reports/grid/${campaignId}/${reportId}/${targetId ? targetId : ""}${
                    compareTo && compareTo !== "" ? "/" + compareTo : ""
                }`,
            null,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            },
        )
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    let end = performance.now();
    console.log(
        "Function " +
            (compareTo ? "Compare GetSEOReportGridWithSproc" : "GetSEOReportGridWithSproc") +
            " took: " +
            (end - start) / 1000 +
            " seconds",
    );

    return response.data;
};

export const GetSEOReportRankWithSproc = async (campaignId, reportId, targetId, compareTo) => {
    let start = performance.now();

    const response = await axios
        .get(
            apiHost +
                `/campaigns/reports/rank/${campaignId}/${reportId}/${targetId ? targetId : ""}${
                    compareTo && compareTo !== "" ? "/" + compareTo : ""
                }`,
            null,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            },
        )
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    let end = performance.now();
    console.log(
        "Function " +
            (compareTo ? "Compare GetSEOReportRankWithSproc" : "GetSEOReportRankWithSproc") +
            " took: " +
            (end - start) / 1000 +
            " seconds",
    );

    return response.data;
};

export const GetSEOReportKeywords = async (campaignId, reportShortName) => {
    const response = await axios
        .get(apiHost + `/campaigns/reports/keywords/list/${campaignId}/${reportShortName}`, null, {
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const GetActiveCampaigns = async (data) => {
    const response = await axios
        .post(apiHost + "/campaigns/list/active", data, {
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const GetCanceledCampaigns = async () => {
    const response = await axios
        .get(apiHost + "/campaigns/list/canceled", null, {
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const GetNewCampaignsForPortal = async () => {
    const response = await axios
        .get(apiHost + "/campaigns/list/new/portal", null, {
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const GetCampaignsForSelect = async () => {
    const response = await axios
        .get(apiHost + "/campaigns/select-list", null, {
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const GetCampaign = async (id) => {
    const response = await axios
        .get(apiHost + "/campaigns/details/" + id, null, {
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const GetCampaignReports = async (id) => {
    const response = await axios
        .get(apiHost + "/seo/reports/list/" + id, null, {
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const GetCampaignKeywords = async (id) => {
    const response = await axios
        .get(apiHost + "/campaigns/" + id + "/keywords/get", null, {
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const GetReportHistoryListWithSprocForPortal = async (campaignId = null) => {
    const response = await axios
        .get(apiHost + "/campaigns/reports/history/list/sproc/portal/" + campaignId, {
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const GetReportHistoryDetails = async (id) => {
    const response = await axios
        .get(apiHost + "/campaigns/reports/history/" + id, {
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const GetReportHistoryTrackingLogs = async (id) => {
    const response = await axios
        .get(apiHost + "/campaigns/reports/history/" + id + "/tracking-logs", {
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const GetCampaignMessagesByType = async (id, type) => {
    const response = await axios
        .get(apiHost + "/campaigns/" + id + "/messages/list/" + type, null, {
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const GetCampaignMessageDetails = async (id) => {
    const response = await axios
        .get(apiHost + "/campaigns/messages/details/" + id, {
            headers: {
                [apiHeader]: apiHeaderValue,
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const CreateCampaignMessage = async (campaignId, data) => {
    const response = await axios
        .post(apiHost + "/campaigns/" + campaignId + "/messages/create", JSON.stringify(data), {
            headers: {
                [apiHeader]: apiHeaderValue,
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const DeleteCampaign = async (id) => {
    const response = await axios
        .patch(apiHost + "/campaigns/" + id + "/delete", null, {
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const CancelCampaign = async (id, data) => {
    const response = await axios
        .patch(apiHost + "/campaigns/" + id + "/cancel", JSON.stringify(data), {
            headers: {
                [apiHeader]: apiHeaderValue,
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const GetCampaignFiles = async (id) => {
    const response = await axios
        .get(apiHost + "/campaigns/" + id + "/files/get", null, {
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const UploadCampaignFiles = async (id, data) => {
    const response = await axios
        .post(apiHost + "/campaigns/" + id + "/files/upload", data, {
            headers: {
                // 'Content-Type' : 'application/json'
                mimeType: "multipart/form-data",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const DeleteCampaignFiles = async (id, data) => {
    const response = await axios
        .post(apiHost + "/campaigns/" + id + "/files/delete", JSON.stringify(data), {
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const SubmitChangeRequest = async (id, data) => {
    const response = await axios
        .post(apiHost + "/campaigns/" + id + "/change-request/submit", data, {
            headers: {
                // 'Content-Type' : 'application/json'
                mimeType: "multipart/form-data",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const SubmitAskQuestionRequest = async (id, data) => {
    const response = await axios
        .post(apiHost + "/campaigns/" + id + "/ask-question/submit", data, {
            headers: {
                // 'Content-Type' : 'application/json'
                mimeType: "multipart/form-data",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const AppLogin = async (data) => {
    const response = await axios
        .post(apiHost + "/accounts/login", JSON.stringify(data), {
            headers: {
                [apiHeader]: apiHeaderValue,
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const AppLoginAs = async (data) => {
    const response = await axios
        .post(apiHost + "/accounts/login-as", JSON.stringify(data), {
            headers: {
                [apiHeader]: apiHeaderValue,
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const GetLoginAsToken = async (data) => {
    const response = await axios
        .post(apiHost + "/accounts/token/get", JSON.stringify(data), {
            headers: {
                [apiHeader]: apiHeaderValue,
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const SendForgotPasswordEmail = async (data) => {
    const response = await axios
        .post(apiHost + "/accounts/forgot-password", JSON.stringify(data), {
            headers: {
                [apiHeader]: apiHeaderValue,
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const ResetUserPassword = async (data) => {
    const response = await axios
        .post(apiHost + "/accounts/reset-password", JSON.stringify(data), {
            headers: {
                [apiHeader]: apiHeaderValue,
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const RegisterUser = async (data) => {
    const response = await axios
        .post(apiHost + "/accounts/register", JSON.stringify(data), {
            headers: {
                [apiHeader]: apiHeaderValue,
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const GetReportSettings = async () => {
    const response = await axios
        .get(apiHost + "/seo/reports/summary/settings/get", null, {
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const GetAdminDefaultSettings = async () => {
    const response = await axios
        .get(apiHost + "/campaigns/settings/get", null, {
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const GetCampaignOrderDetails = async (id) => {
    const response = await axios
        .get(apiHost + "/campaigns/orders/" + id, {
            headers: {
                [apiHeader]: apiHeaderValue,
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const GetRequirementDetails = async (id) => {
    const response = await axios
        .get(apiHost + "/campaigns/requirements/" + id, {
            headers: {
                [apiHeader]: apiHeaderValue,
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const GetRequirementsMessages = async (id) => {
    const response = await axios
        .get(apiHost + "/campaigns/requirements/" + id + "/messages", {
            headers: {
                [apiHeader]: apiHeaderValue,
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const GetProducts = async () => {
    const response = await axios
        .get(apiHost + "/products/", null, {
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const GetUserOffers = async () => {
    const response = await axios
        .get(apiHost + "/offers/sales", null, {
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const GetDefaultOffers = async () => {
    const response = await axios
        .get(apiHost + "/offers/default", null, {
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const GetSystemOffers = async () => {
    const response = await axios
        .get(apiHost + "/offers/system", null, {
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const GetResellerOffers = async () => {
    const response = await axios
        .get(apiHost + "/offers/reseller", null, {
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const GetOffer = async (id) => {
    const response = await axios
        .get(apiHost + "/offers/" + id, null, {
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const AddOffer = async (data) => {
    const response = await axios
        .post(apiHost + "/offers/add", data, {
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const UpdateOffer = async (id, data) => {
    const response = await axios
        .patch(apiHost + "/offers/" + id + "/update", data, {
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const DeleteOffer = async (id) => {
    const response = await axios
        .delete(apiHost + "/offers/" + id + "/delete", null, {
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const ProcessOrder = async (data) => {
    const response = await axios
        .post(apiHost + "/orders/process", JSON.stringify(data), {
            headers: {
                [apiHeader]: apiHeaderValue,
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const CreateNewRequirements = async (data) => {
    const response = await axios
        .post(apiHost + "/campaigns/requirements/create", JSON.stringify(data), {
            headers: {
                [apiHeader]: apiHeaderValue,
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const UpdateRequirements = async (id, data) => {
    const response = await axios
        .patch(apiHost + "/campaigns/requirements/" + id + "/update", JSON.stringify(data), {
            headers: {
                [apiHeader]: apiHeaderValue,
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const CreateRequirementsMessage = async (id, data) => {
    const response = await axios
        .post(apiHost + "/campaigns/requirements/" + id + "/messages/create", JSON.stringify(data), {
            headers: {
                [apiHeader]: apiHeaderValue,
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const ApproveRequirements = async (id) => {
    const response = await axios
        .post(apiHost + "/campaigns/requirements/" + id + "/approve", null, {
            headers: {
                [apiHeader]: apiHeaderValue,
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

//users
export const GetUsers = async () => {
    const response = await axios
        .get(apiHost + "/accounts/list", {
            headers: {
                [apiHeader]: apiHeaderValue,
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const GetSalesUsers = async () => {
    const response = await axios
        .get(apiHost + "/accounts/list/sales", {
            headers: {
                [apiHeader]: apiHeaderValue,
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const GetUser = async () => {
    const response = await axios
        .get(apiHost + "/accounts/details", {
            headers: {
                [apiHeader]: apiHeaderValue,
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const UpdateUser = async (id, data) => {
    const response = await axios
        .patch(apiHost + "/accounts/update/" + id, JSON.stringify(data), {
            headers: {
                [apiHeader]: apiHeaderValue,
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const CancelSubscription = async (id, data) => {
    const response = await axios
        .post(apiHost + "/accounts/" + id + "/subscription/cancel", JSON.stringify(data), {
            headers: {
                [apiHeader]: apiHeaderValue,
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const CreateSalesCompany = async (data) => {
    const response = await axios
        .post(apiHost + "/salescompanies/create", JSON.stringify(data), {
            headers: {
                [apiHeader]: apiHeaderValue,
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

//user subscriptions
export const GetUserSubscription = async (userId) => {
    const response = await axios
        .get(apiHost + "/subscriptions/user/" + userId, {
            headers: {
                [apiHeader]: apiHeaderValue,
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const DeductUserReportCredits = async (data) => {
    const response = await axios
        .post(apiHost + "/subscriptions/" + data.id + "/deduct", JSON.stringify(data), {
            headers: {
                [apiHeader]: apiHeaderValue,
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

//Stripe methods
export const GetUserPayments = async (id) => {
    const response = await axios
        .get(apiHost + "/accounts/" + id + "/payments", {
            headers: {
                [apiHeader]: apiHeaderValue,
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

//Google methods
export const SerpFindGoogleProfileByPlaceId = async (placeId) => {
    const response = await axios
        .get(apiHost + "/seo/find-profile?placeId=" + placeId, {
            headers: {
                [apiHeader]: apiHeaderValue,
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const FindGoogleProfileInformation = async (url) => {
    const response = await axios
        .get(apiHost + "/seo/profile-lookup?mapsUrl=" + url, {
            headers: {
                [apiHeader]: apiHeaderValue,
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const GetGooglePlaceDetails = async (placeId) => {
    const response = await axios
        .get(apiHost + "/seo/google/place?placeId=" + placeId, {
            headers: {
                [apiHeader]: apiHeaderValue,
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const SeoBusinessProfileSearch = async (data) => {
    const response = await axios
        .post(apiHost + "/seo/profile-search", JSON.stringify(data), {
            headers: {
                [apiHeader]: apiHeaderValue,
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

//Sales report
export const GetCurrentUserSalesCompanies = async () => {
    const response = await axios
        .get(apiHost + "/salescompanies/current-user/list", {
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const GetSalesCompanyDetails = async (id) => {
    const response = await axios
        .get(apiHost + "/salescompanies/" + id + "/details", {
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const GetSalesCompanyDetailsBasic = async (id) => {
    const response = await axios
        .get(apiHost + "/salescompanies/" + id + "/details/basic", {
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const GetSalesCompanyByPlaceId = async (placeId) => {
    const response = await axios
        .get(apiHost + "/salescompanies/place-id/" + placeId, {
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const GetSalesCompanyTasks = async (id) => {
    const response = await axios
        .get(apiHost + "/salescompanies/" + id + "/tasks", null, {
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const GetSalesCompanyTaskDetails = async (id) => {
    const response = await axios
        .get(apiHost + "/salescompanies/tasks/" + id + "/details", null, {
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const GetSalesCompanyTaskDetailsWithSproc = async (id) => {
    const response = await axios
        .get(apiHost + "/salescompanies/tasks/" + id + "/details/sproc", null, {
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const GetSalesCompanyTaskDetailsWithSprocBasic = async (id) => {
    const response = await axios
        .get(apiHost + "/salescompanies/tasks/" + id + "/details/sproc/basic", null, {
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const CreateSalesCompanyTask = async (data) => {
    const response = await axios
        .post(apiHost + "/salescompanies/" + data.salesCompanyId + "/tasks/create", JSON.stringify(data), {
            headers: {
                [apiHeader]: apiHeaderValue,
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const UpdateSalesCompany = async (id, data) => {
    const response = await axios
        .patch(apiHost + "/salescompanies/" + id + "/update", JSON.stringify(data), {
            headers: {
                [apiHeader]: apiHeaderValue,
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const DeleteSalesCompany = async (id) => {
    const response = await axios
        .delete(apiHost + "/salescompanies/" + id + "/delete", null, {
            headers: {
                [apiHeader]: apiHeaderValue,
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const UpdateSalesCompanyTask = async (id, data) => {
    const response = await axios
        .patch(apiHost + "/salescompanies/tasks/" + id + "/update", JSON.stringify(data), {
            headers: {
                [apiHeader]: apiHeaderValue,
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const UpdateSalesCompanyTaskAuditData = async (id, data) => {
    const response = await axios
        .patch(apiHost + "/salescompanies/tasks/" + id + "/update-audit-data", JSON.stringify(data), {
            headers: {
                [apiHeader]: apiHeaderValue,
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const UpdateSalesCompanyTaskLocation = async (id, data) => {
    const response = await axios
        .patch(apiHost + "/salescompanies/tasks/" + id + "/update-location", JSON.stringify(data), {
            headers: {
                [apiHeader]: apiHeaderValue,
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const DeleteSalesCompanyTask = async (salesCompanyId, id) => {
    const response = await axios
        .delete(apiHost + "/salescompanies/" + salesCompanyId + "/tasks/" + id + "/delete", null, {
            headers: {
                [apiHeader]: apiHeaderValue,
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const UpdateSalesCompanyTaskIndexes = async (data) => {
    const response = await axios
        .patch(apiHost + "/salescompanies/tasks/update-indexes", JSON.stringify(data), {
            headers: {
                [apiHeader]: apiHeaderValue,
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const GenerateSEOReportDataGrid = async (data) => {
    const response = await axios
        .post(apiHost + "/seo/generate-report-datagrid", JSON.stringify(data), {
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const GetUserReportsListForSalesPortal = async (userId) => {
    const response = await axios
        .get(apiHost + "/salescompanies/" + userId + "/reports/portal/list", {
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const GetUserReportsList = async (userId) => {
    const response = await axios
        .get(apiHost + "/salescompanies/" + userId + "/reports/list", {
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

//competitors
export const GetSalesCompanyCompetitors = async (id) => {
    const response = await axios
        .get(apiHost + "/salescompanies/" + id + "/competitors", null, {
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const CreateSalesCompanyCompetitor = async (data) => {
    const response = await axios
        .post(apiHost + "/salescompanies/" + data.salesCompanyId + "/competitors/create", JSON.stringify(data), {
            headers: {
                [apiHeader]: apiHeaderValue,
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const UpdateSalesCompanyCompetitor = async (id, data) => {
    const response = await axios
        .patch(apiHost + "/salescompanies/competitors/" + id + "/update", JSON.stringify(data), {
            headers: {
                [apiHeader]: apiHeaderValue,
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

//task queue
export const GetSalesCompanyPendingQueueTasks = async (id) => {
    const response = await axios
        .get(apiHost + "/salescompanies/tasks/queue/list/pending", null, {
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const GetTaskQueuesByCompanyId = async (companyId) => {
    const response = await axios
        .get(apiHost + "/salescompanies/" + companyId + "/tasks/queue/list", null, {
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};

export const CreateSalesCompanyTaskQueue = async (taskId, data) => {
    const response = await axios
        .post(apiHost + "/salescompanies/tasks/" + taskId + "/queue/create", JSON.stringify(data), {
            headers: {
                [apiHeader]: apiHeaderValue,
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return { data: { IsSuccessful: false, Message: err } };
        });

    return response.data;
};
